import {
  ZERO_AUTOS_LOADING,
  ZERO_AUTOS_HAS_ERRORED,
  SET_DATA_AUTOS,
  SET_AUTO_SELECCIONADO,
  LIMPIAR_DATOS_AUTOS
} from "./aZeroAutos";

const initialState = {
  autos: [],
  isLoading: false,
  error: null,
  autoSeleccionado: null
};

const reducerZeroAutos = (state = initialState, action) => {
  switch (action.type) {
    case ZERO_AUTOS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };

    case ZERO_AUTOS_HAS_ERRORED:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };

    case SET_DATA_AUTOS:
      return {
        ...state,
        autos: action.payload,
        isLoading: false,
        error: null
      };

    case SET_AUTO_SELECCIONADO:
      return {
        ...state,
        autoSeleccionado: action.payload
      };

    case LIMPIAR_DATOS_AUTOS:
      return {
        ...state,
        autos: [],
        error: null,
        autoSeleccionado: null
      };

    default:
      return state;
  }
};

export default reducerZeroAutos;
